import mitt from 'mitt';

export const events = mitt();
